import script from "./TrainingProgram.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingProgram.vue?vue&type=script&setup=true&lang=js"

import "./TrainingProgram.vue?vue&type=style&index=0&id=0d03d829&scoped=true&lang=postcss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d03d829"]])

export default __exports__